import { z } from 'zod';

import { WhatsNewEntryType } from './whats-new-entry-type';

export type UpdateWhatsNewEntryPayload = z.infer<typeof updateWhatsNewEntryPayloadSchema>;

export const updateWhatsNewEntryPayloadSchema = z.object({
  title: z.string().optional(),
  subtitle: z.string().max(100).optional(),
  message: z.string().optional(),
  link: z.url().nullable().optional(),
  linkTitle: z.string().nullable().optional(),
  type: z.enum(WhatsNewEntryType).optional(),
});
